import moment from 'moment';

// keep time selections on 15-minute increments
const forceTimeInterval = (time) => {
  if (!time) {
    return null;
  }
  let adjustedMin;
  let selectedTimeStr = time.format('MM/DD/YYYY HH:mm')
  let selectedMin = parseInt(time.format('HH:mm').split(':')[1]);
  // console.log(`selectedMin: ${time.format('HH:mm')}`);
  if (selectedMin > 0 && selectedMin < 15) {
    adjustedMin = '00';
  } else if (selectedMin > 15 && selectedMin < 30) {
    adjustedMin = 15;
  } else if (selectedMin > 30 && selectedMin < 45) {
    adjustedMin = 30;
  } else if (selectedMin > 45) {
    adjustedMin = 45;
  } else {
    adjustedMin = selectedMin;
  }
  let adjustedTimeStr = selectedTimeStr.split(':')[0] +  ':' + `${adjustedMin}`;
  // console.log(`adjustedTime: ${adjustedTimeStr}`);
  let adjustedTime = moment(adjustedTimeStr, 'MM/DD/YYYY HH:mm');
  // console.log(adjustedTime);

  return adjustedTime;
}

export default forceTimeInterval;



// WEBPACK FOOTER //
// ./src/utils/forceTimeInterval.js